import axios from 'axios'
import { cnpj as validadorCNPJ, cpf as validadorCPF} from 'cpf-cnpj-validator';
import moment from 'moment';
import { validate } from 'email-validator';
const Swal = require('sweetalert2')
const jwt_decode = require('jwt-decode');


let isProd = process.env.NODE_ENV === 'production';
isProd = true;
axios.defaults.baseURL = (isProd) ? 'https://api.comprodonto.com.br/api/' : 'http://127.0.0.1:8000/api/'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.timeout = 120000;

const corConfirmacao = "#01AA5D"

axios.interceptors.request.use(async (config) => {
    if (
      !config.url.includes('autenticar/admin') ||
      !config.url.includes('viacep.com.br')
    ) {
        let objToken = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
        config.headers.Authorization = (objToken) ? `Bearer ${objToken.token}` : '';
    }
  
    return config;
  }, (error) => {
    // I cand handle a request with errors here
    return Promise.reject(error);
  });

export async function ajax(metodo, url, pacote, headers = null){
    let info;
    await axios[metodo](url, pacote,headers)
    .then(response => {
        info = response.data
    })
    return info
}

export function alerta(type, title, message){
    Swal.fire({
        position: "center",
        type: type,
        title: title,
        text: message,
        showConfirmButton: true,
        confirmButtonColor: corConfirmacao,
    });
}

export function tratamento_requisicao(error, self){

    //console.log(error);

    if(error.response == undefined){
        Swal.fire({
            position: "center",
            type: "error",
            title: "Erro interno do servidor",
            text: "Não identificamos o erro, por favor tente novamente!",
            showConfirmButton: true,
            confirmButtonColor: corConfirmacao,
        });
    }
    let switchIndex = (error.response.status) ? error.response.status : 1;
    switch(switchIndex){
                case 400:
                    Swal.fire({
                        position: "center",
                        type: "error",
                        title: (error.response.data.title) ? error.response.data.title : 'Solicitação Inválida',
                        text: error.response.data.message,
                        showConfirmButton: true,
                        confirmButtonColor: corConfirmacao,
                    });
                    break;
                case 500:
                    Swal.fire({
                        position: "center",
                        type: "error",
                        title: (error.response.data.title) ? error.response.data.title : 'Erro no servidor',
                        text: error.response.data.message,
                        showConfirmButton: true,
                        confirmButtonColor: corConfirmacao,
                    });
                    break;
                    case 401:
                        localStorage.removeItem("token_adm_comprodonto")
                        self.$router.replace(self.$route.query.redirect || "/");
                        Swal.fire({
                            position: "center",
                            type: "warning",
                            title: (error.response.data.title) ? error.response.data.title : 'Não autorizado',
                            text: error.response.data.message,
                            showConfirmButton: true,
                            confirmButtonColor: corConfirmacao,
                        });
                        break;
                    case 408:
                        Swal.fire({
                            position: "center",
                            type: "warning",
                            title: 'Tempo de solicitação esgotado',
                            text: 'Requisição está demorando demais, tente novamente!',
                            showConfirmButton: true,
                            confirmButtonColor: corConfirmacao,
                        });
                        break;
                    default:
                        Swal.fire({
                            position: "center",
                            type: "error",
                            title: "Erro inesperado",
                            text: "Não identificamos o erro, por favor tente novamente!",
                            showConfirmButton: true,
                            confirmButtonColor: corConfirmacao,
                        });
                        break;
            }
}

export function verificaSeEstaLogado(){
    var token = localStorage.getItem("token_adm_comprodonto");
    if(token){
        let tokenDecode = jwt_decode(token);
        return tokenDecode.usr
    }else
        return false
}

export function validaCampos(email, cnpj, telefone, cpf){
    if (email != undefined) {
        if(validate(email) == false ) {
            Swal.fire({
                position: "center",
                type: "error",
                title: "Falha",
                text: "E-mail Invalido",
                showConfirmButton: true,
                confirmButtonColor: corConfirmacao,
            });
          return false;
        }
      }

      if (cnpj != undefined) {
        if(validadorCNPJ.isValid(cnpj) == false) {
            Swal.fire({
                position: "center",
                type: "error",
                title: "Falha",
                text: "CNPJ Invalido",
                showConfirmButton: true,
                confirmButtonColor: corConfirmacao,
            });
          return false;
        }
      }

      if(telefone != undefined) {
        const tel = telefone.replace(/\D/g, "");
        if(tel.length < 10) {
            Swal.fire({
                position: "center",
                type: "error",
                title: "Falha",
                text: "Telefone Invalido",
                showConfirmButton: true,
                confirmButtonColor: corConfirmacao,
            });
          return false;
        }
      }

      if(cpf != undefined) {
          if(validadorCPF.isValid(cpf) == false) {
            Swal.fire({
                position: "center",
                type: "error",
                title: "Falha",
                text: "CPF Invalido",
                showConfirmButton: true,
                confirmButtonColor: corConfirmacao,
            });
          return false;
          }
      }

      return true;
}

export function padronizaHora(horario) {
    return moment.utc(horario).format("HH:mm")
}
export function formataTextoEmNumeral(value) {
    let val = (value / 1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

export function padronizaData(data) {
    return data ? moment(String(data)).format("DD/MM/YYYY") : "";
  }

export function padronizaDataUS(data){
    let dia = data.split("/")[0];
    let mes = data.split("/")[1];
    let ano = data.split("/")[2];
    return `${ano}-${mes}-${dia}`;
}

export function dateToTimestemp(data){
    return data.split('/')[2]+'-'+data.split('/')[1]+'-'+data.split('/')[0]
}

export const ReturnStringErrorByArrayOfErrors = (array_of_errors) => {
    let statusMessage = String(Object.entries(array_of_errors).map(el => `${el[1]}\n`)).replaceAll(',', '');
    return statusMessage;
}